export function apiCall(path: string, data: any, cb: (res: any) => void, method?: string) {
  var oReq = new XMLHttpRequest();
  oReq.addEventListener('load', function () {
    try {
      cb(JSON.parse(oReq.responseText));
    } catch (e) {
      cb(oReq.responseText);
    }
  });
  method = method || (data ? 'POST' : 'GET');
  oReq.open(method, 'api.php' + path);
  if (data) {
    var fd = new FormData();
    fd.append('data', JSON.stringify(data));
    oReq.send(fd as any);
  } else {
    oReq.send();
  }
}

export default apiCall;
